<template>
<div class="all-detail-task" ref='allDetail'>
    <div v-cloak @mouseenter="hoverCurrent=index" @mouseleave="hoverCurrent=-1" class="progress-box-height" :class="[item.open?'progress-box-more':'',item.open&&item.status<3&&isVip()?'progress-box-vipMore':'',item.open&&item.status<3&&!isVip()?'progress-box-more':'',item.open&&item.status==3&&!item.itemProgressInfo?'progress-failed-less':'',taskDatas.length>8?'progress-box-overflow':'progress-box']" v-for="(item, index) in taskDatas" :key="index" @click="collapse(index,item)" :style="{height:getHeight(item,index)}">
        <div class="detailed-progress-box">
            <div v-if="item.itemProgressInfo&&item.itemProgressInfo.percent&&item.itemProgressInfo.percent<100" :class="item.itemProgressInfo&&item.itemProgressInfo.percent?'progress-innerbox':''" :style="{width:item.itemProgressInfo.percent+'%'}"></div>
        </div>
        <div class="task-info">
            <div class="task-info-name">
                <!-- 判断是否成功状态>=4表示成功，状态为3表示取消，如果存在errorList表示失败（需判断部分成功和失败需判断） -->
                <!-- 任务正在运行中 -->
                <div class="task-status-name" v-if="item.status<3&&item.status!=0">{{$t('language.common.transferring')}}:</div>
                <!-- 任务处于准备状态 -->
                <div class="task-status-name" v-if="item.status==0">{{$t('language.common.ready')}}:</div>
                <!-- 成功 -->
                <div class="task-status-name status-green" v-if="!isTaskException(item)&&item.status>=4&&item.errorList&&!item.errorList.length&&item.itemProgressInfo&&item.itemProgressInfo.percent==100">{{$t('language.cloudTransfer.transferSucces')}}:</div>
                <!-- 取消 -->
                <div class="task-status-name status-grey" v-if="item.status==3">{{$t('language.common.canceled')}}:</div>
                <!-- 部分成功 -->
                <div class="task-status-name status-blue" v-if="item.status>=4&&item.errorList&&item.errorList.length>1&&(item.readyTranFileCount/item.totalFileCount)*100>=80">{{$t('language.common.partialSuccess')}}:</div>
                <!-- 失败 -->
                <div class="task-status-name status-grey" v-if="isTaskException(item)||item.status>=4&&((item.errorList&&item.errorList.length&&(item.readyTranFileCount/item.totalFileCount)*100<80))">{{$t('language.common.failure')}}:</div>
                <div :title="item.sourceFilename" class="detailed-sources-name">&nbsp;{{item.sourceFilename}}</div>
            </div>
            <div class="task-info-percent">
                <div v-if="item.itemProgressInfo&&item.itemProgressInfo.percent&&item.itemProgressInfo.percent!=100&&item.itemProgressInfo.percent!=0.00">{{item.itemProgressInfo.percent}}%<span v-if="item.itemProgressInfo&&item.itemProgressInfo.speed">({{item.itemProgressInfo.speed}})</span></div>
            </div>
            <div class="task-info-speed">
                <div class="icon-util taskinfo-collapse-position" :class="item.open?'collapse-up':'collapse-down'" v-if="hoverCurrent==index"></div>
                <div v-if="hoverCurrent==index&&item.status<3&&item.errorList&&!item.errorList.length&&(!item.itemProgressInfo||item.itemProgressInfo.percent!=100)" class="icon-util purple-cancel taskinfo-cancel-position" @click.stop="cancelPasteTask(item,index)"></div>
            </div>
            <div>
                <transferingDetail  v-if="item.status<3||item.status=='ready'||(item.itemProgressInfo&&item.itemProgressInfo.status=='ready'&&item.errorList&&!item.errorList.length)" :open="item.open" :index="index" :itemDetail='item'></transferingDetail>
                <successDetail  v-if="!isTaskException(item)&&item.status>=4&&item.errorList&&!item.errorList.length&&item.itemProgressInfo&&(item.itemProgressInfo.percent==100||item.itemProgressInfo.percent==100.00)" :open="item.open" :index="index" :itemDetail='item'></successDetail>
                <unfinishedDetail  v-if="isTaskException(item)||item.status>=4&&item.errorList&&item.errorList.length>0||item.status==3" :open="item.open" :index="index" :itemDetail='item'></unfinishedDetail>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import transferingDetail from "@/components/common/tabs/tabs_detailed_progress/tab_transfering_detail";
import successDetail from "@/components/common/tabs/tabs_detailed_progress/tab_success_detail";
import unfinishedDetail from "@/components/common/tabs/tabs_detailed_progress/tab_unfinished_detail";
export default {
    components: {
        transferingDetail,
        successDetail,
        unfinishedDetail
    },
    data: function () {
        return {
            statusColor: "",
            clickCurrent: -1,
            hoverCurrent: -1,
            taskDatas: []
        };
    },
    methods: {

         /**
         * 用来判断临时任务是否出现异常（临时不严谨的方法）。
         * （临时处理，拷贝粘贴任务出现异常，但显示成功的问题。）
         * @author wt
         * @param {*} item 
         */
         isTaskException(item){
        var isTaskException = false;
        // 原有成功的条件
        if(item.status>=4&&item.errorList&&!item.errorList.length&&item.itemProgressInfo&&item.itemProgressInfo.percent==100){
            if(!(item.itemProgressInfo.readyBytes||item.itemProgressInfo.readyBytes==0)){
            isTaskException = true;
          }
         }
         return isTaskException;
        },
        collapse(index, item) {
            if (item.open) {
                //关闭展开的任务
                this.$store.state.detailTaskOpen=false;
                item.open=false;
                this.$store.state.detailedProgrssData[index].open=false;
                this.$forceUpdate();
            } else {
               //打开一个未展开的任务
                this.$store.state.detailTaskOpen=true;
               item.open=true;
               this.$store.state.detailedProgrssData[index].open=true;
               this.$forceUpdate();
               $.each(this.taskDatas,function(j,jItem){
                    if(item.taskId!=jItem.taskId&&jItem.open){
                        jItem.open=false;
                    }
               });
                $.each(this.$store.state.detailedProgrssData,function(k,kItem){
                    if(item.taskId!=kItem.taskId&&kItem.open){
                        kItem.open=false;
                    }
               });
            }
        },
        cancelPasteTask(item, index) {
            let allSnapData = this.$parent.$parent.$parent.$parent.$refs.snapTaskDialog.items;
            let taUnfinish=this.$store.state.detailTabUnfinished;
            let that = this;
            if (item.taskId) {
                let cancelData = {
                    ud: commonUtils.getUser().id,
                    type: 4,
                    id: item.taskId,
                    wd: item.taskId
                }
                this.Utils.doTasksRequest('cancel', cancelData).then(response => {
                    if (response.status == 200) {
                        item.status = 3;
                        item.percent = 0;
                        if (item.itemProgressInfo) {
                            delete item.itemProgressInfo.percent;
                            delete item.itemProgressInfo.speed;
                        }
                        $.each(allSnapData, function (i, snapItem) {
                            if (item.sourceFilename == snapItem.name && item.taskId == snapItem.taskId) {
                                item.status = 3;
                                that.$store.state.retryItems.splice(i, 1);
                                that.$parent.$parent.$parent.$parent.$refs.snapTaskDialog.items.splice(i, 1);
                                item.itemProgressInfo = {};
                                that.$store.state.detailedProgrssData = that.taskDatas;
                                taUnfinish.push(item);//加入临时任务失败列表
                                that.$forceUpdate();
                                commonUtils.runDetailProgressData(that.$parent.$parent.$parent.$parent);
                                return false;
                            }
                        });
                        that.$forceUpdate();
                    }
                });
            }else{
                 this.$toast({
                        text: this.$t('language.cloudExploer.cancelFailed'),
                        type: 'fail',
                        idValue: "rightContBan"
                    });
                    return false;
            }
        },
         isVip() {
            let flag = commonUtils.isVip();
            return flag;
        },
        getHeight(item,index){
            let result;
            if( item.itemProgressInfo&&item.itemProgressInfo.entities&&item.itemProgressInfo.entities.length&&item.open&&item.status<3&&this.isVip()){
               result=item.itemProgressInfo.entities.length*22+170+'px !important';
            }
            if( item.itemProgressInfo&&item.itemProgressInfo.entities&&item.itemProgressInfo.entities.length&&item.open&&item.status<3&&!this.isVip()){
               result=item.itemProgressInfo.entities.length*22+220+'px !important';
            }
            return result;

        }
    }
};
</script>

<style>
.detailed-sources-name {
    float: left;
    max-width: 185px;
    /*no*/
    text-overflow: ellipsis;
    overflow: hidden !important;
    white-space: nowrap !important;
}

.detailed-progress-box {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    margin: auto;
    height: 34px;
    /*no*/
    width: 634px;
    /*no*/
    margin-top: 2px;
    /*no*/
}

.progress-innerbox {
    max-width: 100%;
    height: 100%;
    background: #e5f0ff;
}

.task-info-name {
    width: 59%;
    height: 100%;
    float: left;
}

.task-info-percent {
    width: 31%;
    height: 100%;
    float: left;
}

.task-info-speed {
    width: 10%;
    height: 100%;
    float: left;
}

.taskinfo-cancel-position {
    position: relative;
    float: right;
    top: 8px;
    /*no*/
    margin-right: 10px;
    /*no*/
    cursor: pointer;
}

.taskinfo-collapse-position {
    position: relative;
    float: right;
    top: 9px;
    /*no*/
    cursor: pointer;
}

.task-status-name {
    float: left;
}

.status-green {
    color: #24d45a;
}

.status-blue {
    color: #0089ff;
}

.status-grey {
    color: #bfbfbf;
}

.task-info-footer {
    width: 100%;
    height: 150px;
    /*no*/
    float: left;
}

.transfer-detail-title {
    height: 20px;
    /*no*/
    line-height: 20px;
    /*no*/
    font-weight: bold;
    font-size: 12px;
    /*no*/
}

.transfer-detail-des {
    height: 15px;
    /*no*/
    line-height: 15px;
    /*no*/
    font-size: 12px;
    /*no*/
    color: rgba(0, 0, 0, 0.6);
}

.to-destine {
    float: right;
    text-align: left;
    width: 250px;
    /*no*/
}

.task-catelog {
    width: 100%;
    height: 20px;
    /*no*/
    font-size: 12px;
    /*no*/
    color: rgba(0, 0, 0, 0.6);
    float: left;
}

.task-upgrade {
    float: left;
    margin-top: 10px;
    /*no*/
    margin-right: 10px;
    /*no*/
    width: 100%;
    height: 40px;
    /*no*/
    line-height: 20px;
    /*no*/
    font-size: 12px;
    /*no*/
    color: rgba(0, 0, 0, 0.6);
}

.task-upgrade-button {
    width: 100%;
    height: 35px;
    /*no*/
}

.upgrade-now:hover {
    background-color: #f1c159;
    cursor: pointer;
}

.upgrade-now:active {
    background-color: #ffaa46;
}

.slide-enter-active {
    transition: all 0.3s ease;
    height: 100px;
    /*no*/
    overflow: hidden;
}

.slide-leave-active {
    transition: all 0s ease;
    height: 0px;
    /*no*/
    overflow: hidden;
}

.slide-enter,
.slide-leave {
    height: 0;
    opacity: 0;
}

.catelog-color {
    color: #4280fe;
}


</style>



// WEBPACK FOOTER //
// src/components/common/tabs/tabs_detailed_progress/tab_all_tasks.vue